var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"InfoHeader"},[_c('span',{staticClass:"Title",class:_vm.titleClass},[_vm._v(_vm._s(_vm.title))]),(_vm.selectedActor && _vm.hasManagerRights)?_c('actor-options'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }